import { Tooltip as TooltipIcon } from 'common/icons/index';
import { Base, BaseProps } from 'common/layouts/Base';
import { colors } from 'component-library/styles/colors';
import React, { FC } from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

interface TooltipProps extends BaseProps {
  message: string;
}

const StyledTooltipIcon = styled(TooltipIcon)`
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: inline-block;
`;

const StyledReactTooltip = styled(ReactTooltip)`
  max-width: 300px;
`;

export const Tooltip: FC<TooltipProps> = ({ message, ...rest }) => (
  <Base {...rest}>
    <StyledTooltipIcon data-tip={message} />
    <StyledReactTooltip
      backgroundColor={colors.forestGreen}
      className="tooltip-override"
      arrowColor="transparent"
      place="right"
      effect="solid"
    />
  </Base>
);
